import PropTypes from 'prop-types';
import {
    Paper,
    Stack,
    Typography,
    Box,
    Divider,
    Chip,
    IconButton,
} from '@mui/material';
import HistoryEduRoundedIcon from '@mui/icons-material/HistoryEduRounded';
import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';

const formatTimestamp = (ts) => {
    if (!ts) return '';
    try {
        return new Date(ts).toLocaleString();
    } catch (e) {
        return '';
    }
};

const truncate = (text, max = 40) => {
    if (!text) return '-';
    return text.length > max ? `${text.slice(0, max)}…` : text;
};

export default function HistoryPreviewList({ records = [], onSelectRecord = undefined }) {
    if (!records.length) {
        return (
            <Paper
                elevation={0}
                sx={{
                    p: 2,
                    borderRadius: 2,
                    border: '1px dashed #d4d8e4',
                    backgroundColor: '#fafbff',
                }}
            >
                <Typography variant="subtitle2" color="text.secondary">
                    최근 검색 기록이 없습니다.
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    주소를 검색하거나 파일을 업로드해 지도를 확인해 보세요.
                </Typography>
            </Paper>
        );
    }

    const entries = [...records]
        .sort((a, b) => new Date(b.timestamp || 0) - new Date(a.timestamp || 0))
        .map((record, idx) => {
            const isBatch = record.source === 'file';
            const title = record.fileName
                ? record.fileName
                : truncate(
                      record.roadAddress ||
                          record.jibunAddress ||
                          record.input ||
                          (record.layerName ?? '검색 결과')
                  );
            const secondary = isBatch
                ? record.input || record.layerName || '파일 업로드'
                : `${Number(record.x)?.toFixed?.(6) ?? '-'}, ${Number(record.y)?.toFixed?.(6) ?? '-'}`;
            const metaLine = formatTimestamp(record.timestamp);
            return {
                key: record.id ?? idx,
                title,
                secondary,
                metaLine,
                isBatch,
                record,
            };
        });

    const handleHistoryTable = (record) => {
        console.log("select history item, record = ", record)
        // onSelectRecord?.(entry.record);
    };

    return (
        <Paper
            elevation={0}
            sx={{
                borderRadius: 2,
                border: '1px solid #e3e7f0',
                backgroundColor: '#fff',
                overflow: 'hidden',
            }}
        >
            <Box sx={{ p: 2 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        검색 히스토리
                    </Typography>
                    <Chip label={`${records.length}`} size="small" color="primary" />
                </Stack>
            </Box>
            <Divider />
            <Stack spacing={0.5} sx={{ maxHeight: 360, overflowY: 'auto' }}>
                {entries.map((entry) => (
                    <Box
                        key={entry.key}
                        sx={{
                            px: 2,
                            py: 1.5,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5,
                            cursor: 'pointer',
                            '&:hover': {
                                backgroundColor: '#f4f6fb',
                            },
                        }}
                        // onClick={() => onSelectRecord?.(entry.record)}
                        onClick={() => handleHistoryTable(onSelectRecord?.(entry))}
                    >
                        <Box
                            sx={{
                                width: 36,
                                height: 36,
                                borderRadius: '50%',
                                backgroundColor: entry.isBatch ? '#ede7f6' : '#e3f2fd',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#002755',
                                flexShrink: 0,
                            }}
                        >
                            {entry.isBatch ? (
                                <InsertDriveFileRoundedIcon fontSize="small" />
                            ) : (
                                <HistoryEduRoundedIcon fontSize="small" />
                            )}
                        </Box>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography variant="body2" sx={{ fontWeight: 600 }} noWrap>
                                {entry.title}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" noWrap>
                                {entry.secondary}
                            </Typography>
                            {entry.metaLine && (
                                <Typography variant="caption" color="text.disabled" noWrap>
                                    {entry.metaLine}
                                </Typography>
                            )}
                        </Box>
                        <IconButton size="small">
                            <ArrowForwardIosRoundedIcon fontSize="inherit" />
                        </IconButton>
                    </Box>
                ))}
            </Stack>
        </Paper>
    );
}

HistoryPreviewList.propTypes = {
    records: PropTypes.array,
    onSelectRecord: PropTypes.func,
};
